<mat-dialog-content class="text-center">
    <div [innerHTML]="data.title"></div>
</mat-dialog-content>

<mat-dialog-actions>
    <button class='btn btn-lg btn-greengo' mat-button mat-dialog-close [mat-dialog-close]="true" (click)="closeDialog()">
        <span *ngIf="data.dialogType !== dialogType.Confirm">OK</span>
        <span *ngIf="data.dialogType === dialogType.Confirm">Yes</span>
    </button>
    <ng-container *ngIf="data.dialogType !== dialogType.Success">
        <button class='btn btn-lg btn-lead-50' mat-button mat-dialog-close [mat-dialog-close]="false">
            <span *ngIf="data.dialogType == dialogType.Cancel">Cancel</span>
            <span *ngIf="data.dialogType === dialogType.Confirm">No</span>
        </button>
    </ng-container>
</mat-dialog-actions>